module.exports = new __parcel__URL__("dark.aff195af.svg").toString();